import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Component, OnInit, Input } from '@angular/core';

import { CommonProgrammingContext, SharedProgrammingService } from './../../../common/services/shared-programming.service';
import { DeviceEvent } from './../../../common/interfaces/event.interface';
import { Device } from './../../../common/interfaces/item.interface';
import { Command } from '../../../common/params/interfaces/command.interface';
import { ProgrammingUtilsService as Utils } from './../../../common/services/utils.service';
import { BaseRoutingComponent } from '../../../common/base-routing/base-routing.component';



@Component({
  selector: 'prg-select-command',
  templateUrl: './select-command.component.html',
  styleUrls: ['./select-command.component.less']
})
export class SelectCommandComponent extends BaseRoutingComponent implements OnInit {

  device: Observable<Device>;
  commands: Observable<Command[]>;
  ready: Observable<boolean>;

  constructor(
    protected router: Router,
    private route: ActivatedRoute,
    protected store: Store<{ sharedProgramming: CommonProgrammingContext }>,
    private shared: SharedProgrammingService,
    private utils: Utils
  ) {
    super();
    this.commands = this.store.select(s => s.sharedProgramming.action.commands);
    this.device = this.store.select(s => s.sharedProgramming.action.device);
    this.ready = this.shared.isReady;
  }

  ngOnInit() {

  }

  commandSelected(command: Command) {
    console.log('selcmd: command selected', command);
    if (command.params && command.params.length > 0) {
      this.shared.setSelectedAction(command);
      this.router.navigate(['../params'], { relativeTo: this.route });
    } else {
      this.shared.saveAction(command);
    }
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-common/select-command/select-command.component.ts